import { useState } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import logo from '../../assets/OTT-Okta-Tile.png';
import './DisclaimerPage.css';

export default function DisclaimerPage() {
  const { oktaAuth } = useOktaAuth();
  const [agreed, setAgreed] = useState(false);

  return (
    <div className="disclaimer-page">

      <img src={logo} alt="Ohio Talent Track" className="disclaimer-logo" />

      <div className="disclaimer-card">
        <h2 className="disclaimer-title">User Agreement: For Authorized Use Only</h2>

        <div className="disclaimer-content">
          <p>
            The data and information contained in this portal are <strong>CONFIDENTIAL</strong> and
            strictly intended for official JobsOhio <strong>INTERNAL USE</strong> only.
          </p>

          <p>
            In order to access the Ohio Talent Track portal and use the data and information
            contained in it, you must be an Authorized User. For purposes of this User Agreement,
            an "Authorized User" is a JobsOhio employee, consultant, or approved partner who has
            received prior written authorization from the Find Your Ohio Director to access the
            Ohio Talent Track portal.
          </p>

          <p>
            The information contained in the Ohio Talent Track portal is not for external
            distribution or data monetization for profit. Authorized Users should only share
            information and data from the Ohio Talent Track portal with other Authorized Users.
            The data and information contained in the Ohio Talent Track portal shall not be used,
            reproduced, distributed, or communicated to any unauthorized persons, external
            stakeholders, or other third parties.
          </p>

          <p>
            All use of the Ohio Talent Track portal is monitored for security and administrative
            purposes. When you access this portal, you are consenting to such monitoring. Use of
            the Ohio Talent Track portal in violation of these terms is strictly prohibited and
            may constitute a violation of the JobsOhio Standards of Conduct and the JobsOhio
            Employee Handbook.
          </p>

          <p>
            In the rare event of a data sync issue due to timing or permission constraints, our
            support team is available to review your case and provide personalized assistance.
          </p>

          <p>
            For questions or support, please email <a href="mailto:enterprisedata@jobsohio.com">enterprisedata@jobsohio.com</a>.
          </p>

          <p>
            By checking this box and clicking "Login" below, you are agreeing to the terms and
            conditions set forth above.
          </p>
        </div>

        <label className="disclaimer-agree">
          <input
            type="checkbox"
            className="disclaimer-agree__checkbox"
            checked={agreed}
            onChange={(e) => setAgreed(e.target.checked)}
          />
          I agree to the above and wish to continue
        </label>

        <button
          className={`disclaimer-btn${agreed ? " disclaimer-btn--active" : ""}`}
          onClick={() => agreed && oktaAuth.signInWithRedirect()}
        >
          Login
        </button>
      </div>

    </div>
  );
}
